import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

export const MinimalLines: React.FC<{ opacity?: number }> = ({ opacity = 1 }) => {
  const frame = useCurrentFrame();

  // Subtle horizontal lines that draw themselves
  const lines = Array.from({ length: 5 }, (_, i) => {
    const yPos = 20 + i * 15;
    const delay = i * 10;
    const progress = interpolate(frame, [delay, delay + 60], [0, 1], {
      extrapolateLeft: "clamp", extrapolateRight: "clamp",
    });
    const lineOpacity = 0.04 + (i === 2 ? 0.04 : 0);

    return { yPos, progress, opacity: lineOpacity };
  });

  // Accent dot that drifts
  const dotX = 15 + Math.sin(frame / 80) * 5;
  const dotY = 50 + Math.cos(frame / 100) * 3;
  const dotOpacity = interpolate(frame, [0, 30], [0, 0.3], { extrapolateRight: "clamp" });

  return (
    <AbsoluteFill style={{ opacity }}>
      {lines.map((l, i) => (
        <div key={i} style={{
          position: "absolute",
          top: `${l.yPos}%`,
          left: "10%",
          width: `${l.progress * 80}%`,
          height: 1,
          backgroundColor: "#D4A843",
          opacity: l.opacity,
        }} />
      ))}
      {/* Subtle accent dot */}
      <div style={{
        position: "absolute",
        left: `${dotX}%`,
        top: `${dotY}%`,
        width: 4,
        height: 4,
        borderRadius: "50%",
        backgroundColor: "#F37021",
        opacity: dotOpacity,
      }} />
      {/* Corner accent line */}
      <div style={{
        position: "absolute",
        bottom: "8%",
        right: "8%",
        width: interpolate(frame, [20, 50], [0, 60], { extrapolateLeft: "clamp", extrapolateRight: "clamp" }),
        height: 1,
        backgroundColor: "#F37021",
        opacity: 0.15,
      }} />
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
